import createOrdersAtom from './orders.js'

export const ordersAtomDefinition = {
  id: 'ordersAtom',
  type: 'atom',
  factory: createOrdersAtom,
  dependencies: ['storage'],
  public: true,
}
